"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SocialIcon;
const React = require("react");
function SocialIcon({ url, icon }) {
    return (React.createElement("a", { className: "btn", target: "_blank", rel: "noopener noreferrer", href: url },
        React.createElement("i", { className: `fab ${icon} fa-2x` })));
}
